import { ClickAway } from '@components/core-ui/ClickAway';
import React from 'react';

import { Wrapper } from './styles/Wrapper';

type TProps = {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
};

export const Modal = ({ children, isOpen, onClose }: TProps) => {
  if (!isOpen) {
    return null;
  }

  return (
    <Wrapper>
      <ClickAway onClickAway={onClose}>{children}</ClickAway>
    </Wrapper>
  );
};
